import { trackPromise } from 'react-promise-tracker';
import { api } from '../../../../../../lib';
import { CategoryRole, SaveCategoryLevelRequest, SaveCategoryLevelsResponse } from './types';

export const getMarginAndRoleCategoryCalculation = async (): Promise<CategoryRole> => {
  const response = await trackPromise(
    api.get<CategoryRole>('/setup/category-role/category', {
      expectToken: true,
    }),
    '/setup/v1/category-role/category',
  );
  return response.data;
};

export const getOptimizationCategoryLevel = async (): Promise<CategoryRole> => {
  const response = await trackPromise(
    api.get<CategoryRole>('/setup/optimization/category', {
      expectToken: true,
    }),
    '/setup/v1/optimization/category',
  );
  return response.data;
};

export const saveCategoryLevels = async ({
  categoryLevels,
  // categoryRoleLevel,
  objectiveMarginLevel,
  optimizationCategory,
}: SaveCategoryLevelRequest): Promise<SaveCategoryLevelsResponse> => {
  try {
    const data = {
      objective_margin_level: objectiveMarginLevel,
      category_role_level: null,
      // TODO: vamos liberar apenas quando liberar o papel de categoria
      // category_role_level: categoryRoleLevel,
      category_levels: categoryLevels,
      optimization_level: optimizationCategory,
    };
    const response = await trackPromise(
      api.put<SaveCategoryLevelsResponse>(`/setup/category-level-config`, data, {
        expectToken: true,
      }),
      '/setup/v1/category-level-config',
    );
    return response.data;
  } catch (err) {
    throw new Error('Erro ao salvar níveis de categoria');
  }
};
